/* eslint-disable no-undef */
APP.TabSwitch = function (containerSelector, tabsSelector, itemsSelector, showClass) {
  this.containerSelector = containerSelector;
  this.tabsSelector = tabsSelector;
  this.itemsSelector = itemsSelector;
  this.showClass = showClass || 'active';

  this.container = document.querySelector(this.containerSelector);
  this.tabs = this.container.querySelectorAll(this.tabsSelector);
  this.items = this.container.querySelectorAll(this.itemsSelector);

  this._initTabs();
  this._hideApps();
};

APP.TabSwitch.prototype._showTabs = function () {
  var tabs = document.querySelector('.platform-tabs.switch-tabs');
  if (!tabs) {
    return;
  }
  tabs.classList.add('visible');
};

APP.TabSwitch.prototype._initTabs = function () {
  this._showTabs();
  this.container.addEventListener(
    'click',
    function (evt) {
      var clickedTab = evt.target;

      while (clickedTab && clickedTab.tagName !== 'LI') {
        clickedTab = clickedTab.parentElement;
      }
      if (!clickedTab || clickedTab.classList.contains(this.showClass) || !clickedTab.attributes['data-id']) {
        return;
      }

      var showItemClass = clickedTab.attributes['data-id'].value;
      this._showItems(this.tabs, showItemClass, this.showClass);

      this._hideApps();
    }.bind(this)
  );

  var showItemClass = APP.utils.getClientOsClass();

  if (showItemClass) {
    this._showItems(this.tabs, showItemClass, this.showClass);
    this._hideApps();
  }
};

APP.TabSwitch.prototype._showItems = function (items, showItemClass, showClass) {
  Array.prototype.slice.call(items).forEach(function (item) {
    if (item.classList.contains(showClass) && item.classList.contains(showItemClass)) {
      return;
    }

    if (item.classList.contains(showItemClass)) {
      item.classList.add(showClass);
      item.classList.remove('hidden');
    } else {
      item.classList.remove(showClass);
      item.classList.add('hidden');
    }
  });
};

APP.TabSwitch.prototype._hideItems = function (items, showItemClass, hideClass) {
  Array.prototype.slice.call(items).forEach(function (item) {
    if (item.classList.contains(hideClass) && item.classList.contains(showItemClass)) {
      return;
    }

    if (item.classList.contains(showItemClass)) {
      item.classList.add(hideClass);
    } else {
      item.classList.remove(hideClass);
    }
  });
};

APP.TabSwitch.prototype._showActiveApps = function () {
  var activeClass = document.querySelector(this.tabsSelector + '.' + this.showClass).getAttribute('data-id');
  Array.prototype.slice.call(this.items).forEach(function (item) {
    if (item.classList.contains(activeClass)) {
      item.classList.add('active');
    } else {
      item.classList.remove('active');
      item.classList.add('hidden');
    }
  });
};

APP.TabSwitch.prototype._hideApps = function () {
  var activeClass = document.querySelector(this.tabsSelector + '.' + this.showClass).getAttribute('data-id');

  Array.prototype.slice.call(this.items).forEach(function (item) {
    item.classList.remove('hidden');

    var images = item.getElementsByTagName('img');
    Array.prototype.slice.call(images).forEach(function (image) {
      image.classList.remove('hidden');
    });

    if (item.classList.contains(activeClass)) {
      Array.prototype.slice.call(images).forEach(function (image) {
        if (image.getAttribute('data-' + activeClass) === 'false') {
          image.classList.add('hidden');
        }
      });
    } else {
      item.classList.add('hidden');
    }
  });
};
